var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.5V11.3333C7.5 10.8666 7.5 10.6333 7.59083 10.455C7.67072 10.2982 7.79821 10.1707 7.95501 10.0908C8.13327 10 8.36662 10 8.83333 10H11.1667C11.6334 10 11.8667 10 12.045 10.0908C12.2018 10.1707 12.3293 10.2982 12.4092 10.455C12.5 10.6333 12.5 10.8666 12.5 11.3333V17.5M1.66666 7.91667L9.2 2.26667C9.48688 2.0515 9.63032 1.94392 9.78786 1.90245C9.92692 1.86585 10.0731 1.86585 10.2121 1.90245C10.3697 1.94392 10.5131 2.05151 10.8 2.26667L18.3333 7.91667M3.33333 6.66667V14.8333C3.33333 15.7668 3.33333 16.2335 3.51499 16.59C3.67478 16.9036 3.92975 17.1586 4.24335 17.3183C4.59987 17.5 5.06658 17.5 6 17.5H14C14.9334 17.5 15.4001 17.5 15.7567 17.3183C16.0703 17.1586 16.3252 16.9036 16.485 16.59C16.6667 16.2335 16.6667 15.7668 16.6667 14.8333V6.66667L11.6 2.86667C11.0262 2.43634 10.7394 2.22118 10.4243 2.13824C10.1462 2.06503 9.85384 2.06503 9.57572 2.13824C9.26065 2.22118 8.97376 2.43634 8.4 2.86667L3.33333 6.66667Z",
    stroke: "#0D0F14",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.bcaa396a5bd5f8fb24396178f0b74b15.svg";
export { ForwardRef as ReactComponent };